import styled from 'styled-components'
import { colorTheme } from '../../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../../style/theme'

export const MarkReadyOrderModalWrapper = styled.span`
	display: contents;
`
MarkReadyOrderModalWrapper.displayName = 'MarkReadyOrderModalWrapper'

export const MarkReadyOrderModalText = styled.div`
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.5em;
	text-align: center;
	color: ${colorTheme.modal.action.text};
`
MarkReadyOrderModalText.displayName = 'MarkReadyOrderModalText'

export const MarkReadyOrderModalSuccessWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.63em;

	> svg {
		width: 3.5em;
		height: 3.5em;
		flex-shrink: 0;
	}
`
MarkReadyOrderModalSuccessWrapper.displayName = 'MarkReadyOrderModalSuccessWrapper'

export const MarkReadyOrderModalErrorRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.31em;
	margin-top: 0.63em;
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.13em;
	color: ${colorTheme.modal.buttons.markReady.error.text};

	> svg {
		width: 1.13em;
		height: 1.13em;
		fill: ${colorTheme.modal.buttons.markReady.error.text};
		flex-shrink: 0;
	}
`
MarkReadyOrderModalErrorRow.displayName = 'MarkReadyOrderModalErrorRow'
